import WidgetsRender, { WidgetItem } from '@/components/main/widgets/WidgetsRender';
import BannerSlider from './BannerSlider';
import { SliderItemFrom } from '@/core/models/slider-model';

type MainViewProps = {
    slides: SliderItemFrom[];
    widgets?: WidgetItem[];
};

export default async function MainView({ slides, widgets }: MainViewProps) {
    return (
        <>
            <BannerSlider slides={slides} />
            <div className="mt-10 space-y-18">
                <WidgetsRender widgets={widgets} />
            </div>
        </>
    );
}
